<template>
  <div class="lang" @click="isOpen = !isOpen">
    <img :src="currentFlag" :alt="currentLang" />
    <p>{{ currentLabel }}</p>

    <div class="lang__arrow">
      <SvgIcon id="arrow" />
    </div>

    <DropDown :is-open="isOpen" class="lang__dropdown">
      <RouterLink :to="switchLink" class="lang__item">
        <img :src="otherFlag" :alt="otherLang" />
        <p>{{ otherLabel }}</p>
      </RouterLink>
    </DropDown>
  </div>
</template>

<script>
export default {
  name: 'LangButton',
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    currentLang() {
      return this.$i18n.locale
    },
    currentLabel() {
      return this.currentLang === 'fr' ? 'Français' : 'English'
    },
    currentFlag() {
      return this.currentLang === 'fr' ? '/images/flags/fr.svg' : '/images/flags/en.png'
    },
    otherLang() {
      return this.currentLang === 'fr' ? 'en' : 'fr'
    },
    otherLabel() {
      return this.currentLang === 'fr' ? 'English' : 'Français'
    },
    otherFlag() {
      return this.currentLang === 'fr' ? '/images/flags/en.png' : '/images/flags/fr.svg'
    },
    switchLink() {
      return this.currentLang === 'fr' ? '/en' : '/'
    }
  }
}
</script>
